import {
  Checkbox,
  FormControlLabel,
  FormHelperText,
  FormGroup,
  SxProps,
} from "@mui/material";
import styles from "./styles";

interface CheckboxFieldProps {
  id: string;
  label: string;
  checked: boolean;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  errorMessage?: string;
  sx?: SxProps;
}

const CheckboxField = ({
  id,
  label,
  checked,
  onChange,
  errorMessage,
  sx = {},
}: CheckboxFieldProps) => {
  return (
    <FormGroup sx={sx}>
      <FormControlLabel
        control={
          <Checkbox
            id={id}
            checked={checked}
            onChange={onChange}
            color="primary"
          />
        }
        label={label}
      />
      {errorMessage && (
        <FormHelperText sx={styles.errorMessage}>{errorMessage}</FormHelperText>
      )}
    </FormGroup>
  );
};

export default CheckboxField;
